const POTENTIAL_BANDS = ['none', 'low', 'moderate', 'high', 'very-high'] as const;
export type PotentialBand = (typeof POTENTIAL_BANDS)[number];

/** Lower edges of the bands above `none`; the same edges as `bandOfExposure` in ai-transformation/model. */
const BAND_FLOORS: readonly (readonly [band: PotentialBand, floor: number])[] = [
    ['very-high', 0.725],
    ['high', 0.475],
    ['moderate', 0.25],
    ['low', 0.075],
];

/** The automation-potential band of a share of effort between 0 and 1. */
export const potentialBandOf = (share: number): PotentialBand =>
    BAND_FLOORS.find(([, floor]) => share >= floor)?.[0] ?? 'none';
